
import {
  Search,
  Calendar,
  Users,
  Radio,
  BarChart,
  FileText,
  Share,
  BrainCircuit
} from "lucide-react";

interface FeatureItem {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const FeaturesSection = () => {
  const features: FeatureItem[] = [
    {
      icon: <Search className="h-8 w-8 text-primary" />,
      title: "Smart Guest Discovery",
      description: "Find perfect guests based on their recent activity and expertise in your podcast's niche."
    },
    {
      icon: <Users className="h-8 w-8 text-primary" />,
      title: "Guest Research & Outreach",
      description: "Automatically research potential guests and craft personalized invitations."
    },
    {
      icon: <Calendar className="h-8 w-8 text-primary" />,
      title: "Scheduling Made Easy",
      description: "Streamline booking with smart calendars and automatic guest prep."
    },
    {
      icon: <BrainCircuit className="h-8 w-8 text-primary" />,
      title: "AI-Powered Show Prep",
      description: "Generate intelligent questions and talking points based on deep research of your guest's expertise."
    },
    {
      icon: <FileText className="h-8 w-8 text-primary" />,
      title: "Content Generation",
      description: "Automatically create show notes, transcripts, and SEO-optimized blog content after each episode."
    },
    {
      icon: <Share className="h-8 w-8 text-primary" />,
      title: "Social Media Automation",
      description: "Generate and schedule platform-specific posts to promote your episodes across all channels."
    },
    {
      icon: <Radio className="h-8 w-8 text-primary" />,
      title: "Post-Production",
      description: "Automate audio enhancement, clip creation, and multi-platform publishing."
    },
    {
      icon: <BarChart className="h-8 w-8 text-primary" />,
      title: "Growth Analytics",
      description: "Track performance metrics and get AI-powered suggestions to grow your audience."
    }
  ];

  return (
    <section className="py-16 bg-card">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-bold mb-4">The Ultimate Podcast Assistant</h2>
          <p className="text-muted-foreground">
            Chat, delegate, and brainstorm. Agent V gives you the space to focus on creating exceptional shows.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-background p-6 rounded-lg border border-border">
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
